<template>
    <div class="container">
        <div class="card border-0 border-light shadow">
            <div class="card-body">
                <p class="step-content-dropdown-text card-text">
                    <span v-for="(part, index) in splitText">
                        <span v-html="part"></span>
                        <VariantsDropdown
                            :value="getValueByQuestionCode('part' + (index + 1))"
                            :question="getQuestionByCode('part' + (index + 1))"
                            v-on:input="onInput"
                        ></VariantsDropdown>
                    </span>
                    <span>{{ last }}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import VariantsDropdown from "./VariantsDropdown"

    export default {
        components: {
            VariantsDropdown
        },

        data() {
            return {
                last: ''
            }
        },

        mounted() {
            this.$emit('start-countdown')
            console.log(this)
        },

        props: {
            step: Object,
            value: Object
        },

        computed: {
            splitText() {
                let reg = /\#.*?\#/g
                let text = this.step.content.split(reg)
                this.last = text.pop()
                return text
            }
        },

        methods: {
            getQuestionByCode(code) {
                return this.step.questions.find((question) => {
                    return !!(question.text && question.text === code);
                })
            },

            getValueByQuestionCode(code) {
                const question = this.getQuestionByCode(code)

                if (question && question.id && this.value && this.value['q' + question.id]) {
                    return this.value['q' + question.id];
                }

                return ''
            },

            onInput(answer) {
                let key = 'q' + answer.questionId
                console.log(answer)
                console.log(this.value)
                this.value[key] = answer.value
                this.$emit('input', this.value)
            },
        }
    }
</script>
